import settings from '~/common/constants/settings.json';
import moment, { Duration, Moment } from 'moment';
import * as durationFns from 'duration-fns';
import * as dateFns from 'date-fns';

export const numberToDuration = (durationAsNumber: number): Duration => {
  return moment.duration({ seconds: durationAsNumber });
};

export const stringToDuration = (durationAsString: string): Duration => {
  return numberToDuration(parseInt(durationAsString));
};

export const formattedStringToMicroseconds = (
  durationString: string | [string, string]
): number | [number, number] => {
  if (typeof durationString !== 'string') {
    const [n1, n2] = durationString;
    return [
      formattedStringToMicroseconds(n1) as number,
      formattedStringToMicroseconds(n2) as number,
    ];
  }
  if (!durationString?.length) {
    return 0;
  }
  const [hh, mm, ss] = durationString.split(':');
  return (
    (parseInt(hh) * 60 * 60 + parseInt(mm) * 60 + parseInt(ss)) * 1000 * 1000
  );
};

export const microsecondsToFormattedDurationString = (
  micros: number | [number, number]
): string | [string, string] => {
  if (typeof micros !== 'number') {
    const [m1, m2] = micros;
    return [
      microsecondsToFormattedDurationString(m1) as string,
      microsecondsToFormattedDurationString(m2) as string,
    ];
  }
  const timeInMiliseconds = micros / 1000;
  let h, m, s;
  h = Math.floor(timeInMiliseconds / 1000 / 60 / 60);
  m = Math.floor((timeInMiliseconds / 1000 / 60 / 60 - h) * 60);
  s = Math.floor(((timeInMiliseconds / 1000 / 60 / 60 - h) * 60 - m) * 60);
  s = s < 10 ? `0${s}` : `${s}`;
  m = m < 10 ? `0${m}` : `${m}`;
  h = h < 10 ? `0${h}` : `${h}`;
  return `${h}:${m}:${s}`;
};

export const getDurationInCorrectType = (
  duration: number | Duration
): Duration => {
  if (typeof duration === 'number') return numberToDuration(duration);
  if (typeof duration === 'string') return stringToDuration(duration);
  return duration;
};
export const durationToString = (dur: Duration): string => {
  let duration = getDurationInCorrectType(dur);
  if (!duration.isValid()) duration = moment.duration(0, 'seconds');
  return moment
    .utc(duration.asMilliseconds())
    .format(settings.apiDurationForamt);
};
export const durationToHour = (dur: Duration) => {
  let durationString = durationToString(dur);
  durationString = durationString.substr(0, 2);
  return parseInt(durationString);
};

export const durationToSeconds = (duration: Duration): number =>
  Math.floor(duration.asSeconds());

export const durationFromTimeStamp = (m: Moment): Duration =>
  moment.duration(moment().diff(m));

export const durationSecondsFromTimeStamp = (m: Moment): number =>
  moment().diff(m, 'seconds');

export const durationToStringPg = (dur: Duration | string) => {
  if (typeof dur === 'string') {
    return durationToString(moment.duration({ seconds: parseFloat(dur) }));
  }
  return durationToString(dur);
};

export const secondsToDuration = (
  seconds: number | null | undefined
): dateFns.Duration | null => {
  if (typeof seconds !== 'number') {
    return {};
  }
  return dateFns.intervalToDuration({ start: 0, end: seconds * 1000 });
};

export const asHMS = (
  duration: dateFns.Duration | null | undefined
): { hours: number; minutes: number; seconds: number } => {
  if (!duration) {
    return { hours: 0, minutes: 0, seconds: 0 };
  }
  let seconds = durationFns.toSeconds(duration);
  const hours = Math.floor(seconds / 60 / 60);
  seconds -= hours * 60 * 60;
  const minutes = Math.floor(seconds / 60);
  seconds -= minutes * 60;
  seconds = Math.floor(seconds);
  return { hours, minutes, seconds };
};

export const normalizeToSeconds = (
  duration: dateFns.Duration | null | undefined
): number => {
  if (!duration) {
    return 0;
  }
  return durationFns.toSeconds(durationFns.normalize(duration));
};
